import React from "react";
import { Dialog, DialogContent, Box, Button } from "@mui/material";
import { withStyles } from "@mui/styles";

const StyledModal = withStyles(() => ({
  root: {
    "& .MuiDialog-root": {
      zIndex: "1301 !important",
    },
    "&.MuiDialog-container": {
      overflowY: "hidden !important",
    },
    "& .MuiDialog-paperScrollPaper": {
      backgroundColor: "#ffffff !important",
      height: "auto",
      boxShadow: "0px 0px 8px 1px",
      border: "1px solid black",
      borderRadius: "20px",
    },
    "& .dialoge__content__section": {
      background: "#ffffff !important",
    },
    "& .MuiDialogContent-root": {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
}))(Dialog);

function NetworkChange({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };
  const networkHandler = async () => {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x38" }], //BSC Mainnet
        // params: [{ chainId: "0x61" }],
      });
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <div className="modal__main__container">
        <StyledModal
          open={open}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className="dialoge__content__section">
            <Box
              borderRadius="100px"
              display="flex"
              alignItems="center"
              flexDirection="column"
              py={3}
            >
              <Box
                borderBottom="5px solid red"
                color="red"
                fontSize="30px"
                fontWeight="600"
              >
                Error!
              </Box>
              <Box
                component="h3"
                color="#000"
                py={2}
                sx={{ fontSize: { md: "20px", xs: "14px" } }}
              >
                You are on wrong network please switch your network.
              </Box>
              <Box align="center">
                <Button
                  sx={{
                    border: "2px solid #2836FF",
                    background: "#D3DCFB",
                    borderRadius: "10px",
                    color: "#000",
                    padding: { md: " 0.7rem 4rem ", xs: "0.7rem 2rem" },
                    textTransform: "none",
                    "&:hover": {
                      background: "#D3DCFB",
                    },
                  }}
                  onClick={networkHandler}
                >
                  Switch Network
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </StyledModal>
      </div>
    </div>
  );
}

export default NetworkChange;
